
const comparisonData = {
  headers: ['', 'Pro v1.1', 'Core v1.0', 'Style v1.0'],
  rows: [
    { label: '価格（Black / 税込）', values: ['¥123,200', '¥79,200', '¥69,300'] },
    { label: 'ヘッドレスト', values: ['4D（標準）', '4D（別売り）', '—'] },
    { label: 'アームレスト', values: ['6D', '4D', '3D'] },
    { label: 'ランバーサポート', values: ['2D アダプティブ', '前後上下調整', '—'] },
    { label: 'リクライニング', values: ['90-135°', '90-120°', '90-110°'] },
    { label: 'シートスライド', values: ['○', '○', '—'] },
    { label: '座面素材', values: ['高密度メッシュ', 'メッシュ', 'ファブリック'] },
    { label: '耐荷重', values: ['150kg', '120kg', '100kg'] },
    { label: '本体重量', values: ['22kg', '18kg', '14kg'] },
    { label: '保証期間', values: ['5年', '3年', '2年'] },
  ],
};

export default function ChairLineupComparison() {
  return (
    <section className="py-20 sm:py-28 bg-gray-50" aria-labelledby="comparison-heading">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <h2
            id="comparison-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-4 tracking-[0.1em]"
          >
            Compare Models
          </h2>
          <p className="text-sm sm:text-base font-extralight text-black/50 tracking-wide">
            3モデルのスペックを比較
          </p>
        </div>

        <div className="bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-sm">
          {/* Desktop Table */}
          <div className="hidden sm:block overflow-x-auto">
            <table className="w-full text-left" role="table">
              <thead>
                <tr className="border-b border-gray-100">
                  {comparisonData.headers.map((header, idx) => (
                    <th
                      key={idx}
                      className={`px-6 py-5 text-sm font-light tracking-wide ${
                        idx === 0 ? 'text-black/40 w-[200px]' : 'text-black text-center'
                      }`}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {comparisonData.rows.map((row, rowIdx) => (
                  <tr
                    key={rowIdx}
                    className={rowIdx !== comparisonData.rows.length - 1 ? 'border-b border-gray-50' : ''}
                  >
                    <td className="px-6 py-4 text-sm font-light text-black/60 tracking-wide">
                      {row.label}
                    </td>
                    {row.values.map((val, valIdx) => (
                      <td
                        key={valIdx}
                        className={`px-6 py-4 text-sm font-light text-center tracking-wide ${
                          val === '—' ? 'text-black/25' : 'text-black'
                        }`}
                      >
                        {val}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="sm:hidden divide-y divide-gray-50">
            {comparisonData.rows.map((row, rowIdx) => (
              <div key={rowIdx} className="px-5 py-4">
                <p className="text-xs font-light text-black/40 mb-2 tracking-wide">{row.label}</p>
                <div className="grid grid-cols-3 gap-2">
                  {comparisonData.headers.slice(1).map((header, idx) => (
                    <div key={idx} className="text-center">
                      <p className="text-[10px] text-black/30 mb-0.5">{header}</p>
                      <p className={`text-sm font-light ${row.values[idx] === '—' ? 'text-black/25' : 'text-black'}`}>
                        {row.values[idx]}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
